import { GraphQLOperationFailed } from '../../adapter/GraphQLClient';

export const handleGoogleError = (err: GraphQLOperationFailed) => {
  switch (err.type) {
    case 'AlreadyAuthorizedError':
      throw new AlreadyAuthorizedError();
    case 'AlreadyLinkedError':
      throw new AlreadyLinkedError();
    case 'ChannelUnlinkedError':
      throw new ChannelUnlinkedError();
    case 'ClientError':
      throw new ClientError();
    case 'InternalServerError':
      throw new InternalServerError();
    case 'NoRefreshTokenError':
      throw new NoRefreshTokenError();
    case 'PermissionDeniedError':
      throw new PermissionDeniedError();
    case 'TokenInvalidError':
      throw new TokenInvalidError();
    default:
      throw err;
  }
};

export class AlreadyAuthorizedError extends Error {
  public readonly name = 'AlreadyAuthorizedError';
  public readonly message = 'message.google_already_authorized';
  constructor() {
    super();
  }
}

export class AlreadyLinkedError extends Error {
  public readonly name = 'AlreadyLinkedError';
  public readonly message = 'message.google_ads_already_linked';
  constructor() {
    super();
  }
}

export class ChannelUnlinkedError extends Error {
  public readonly name = 'ChannelUnlinkedError';
  public readonly message = 'message.google_youtube_channel_is_not_linked';
  constructor() {
    super();
  }
}

export class ClientError extends Error {
  public readonly name = 'ClientError';
  public readonly message = 'message.google_client_error';
  constructor() {
    super();
  }
}

export class InternalServerError extends Error {
  public readonly name = 'InternalServerError';
  public readonly message = 'message.google_internal_server_error';
  constructor() {
    super();
  }
}

export class NoRefreshTokenError extends Error {
  public readonly name = 'NoRefreshTokenError';
  public readonly message = 'message.google_cannot_fetch_refresh_token';
  constructor() {
    super();
  }
}

export class PermissionDeniedError extends Error {
  public readonly name = 'PermissionDeniedError';
  public readonly message = 'message.google_permission_denied';
  constructor() {
    super();
  }
}

export class TokenInvalidError extends Error {
  public readonly name = 'TokenInvalidError';
  public readonly message = 'message.google_token_invalid';
  constructor() {
    super();
  }
}
